import React from "react";
import PropTypes from "prop-types";
import { Button } from "@material-ui/core";
import clsx from "classnames";

import { useStyles } from "../../hooks";
import styles from "./styles";

const ButtonSmg = ({
  content,
  theme = "material",
  color = "default",
  size = "medium",
  variant = "contained",
  fullWidth = false,
  disabled = false,
  disableRipple = false,
  buttonNav = false,
  buttonRoot = true,
  className,
  customClassName,
  classes,
  ...props
  
}) => {
  const classesStyle = useStyles(styles);

  return (
    <Button
      className={customClassName ? customClassName : clsx(className, { [classesStyle.buttonNav]: buttonNav, [classesStyle.root]: buttonRoot })}
      color={color}
      classes= {classes ? classes: {label: classesStyle.label}}
      size={size}
      variant={variant}
      fullWidth={fullWidth}
      disabled={disabled}
      disableRipple={disableRipple}
      {...props}
    >
      {content}
    </Button>
  );
};

ButtonSmg.propTypes = {
  id: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  theme: PropTypes.oneOf(["material", "boostrap"]),
  color: PropTypes.oneOf(["default", "inherit", "primary", "secondary"]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  variant: PropTypes.oneOf(["contained", "outlined", "text"]),
  href: PropTypes.string,
  onClick: PropTypes.func,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  disableRipple: PropTypes.bool,
  buttonNav: PropTypes.bool,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  classes: PropTypes.object
};

export default ButtonSmg;
